module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAABMUlEQVQ4ja2UrU4DURCFv9lgEUgwSBSCNJBgCIoEggMBplVYkqlDQAKWwIQ3oIakCSh+bMMLVCFIDS+A4A0G0b3ldrPbXTY78sy5X87cP3F3mihRloDtuYZgu8AbQNIA7DbAgFbthKIsAs9AK5VW3BjVAoqyBbwA8yGZGyOoMbIobeA9gu27MQz9fwFFOQV6kdR14zX2JKlxTZTjEtg5cBdJfTcs60tEOQGGwIMoNwWwC+Aqkr7cOMrzJsBePIIoA1EWIpgCl5l1O4WTuDui3AOdSP8GNoBlYJBZ080bdQqYJukB7SJjWh9urM4yTE7ZjQ7QLwEelPSnr0260U8F3utweWeV5P02ojxm0vy4/R1U5YSh3Dhk/LRCnVWBFSacNJVPxo9eqgLLPodNYL0qDOAX+RtSAvECeTgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/graduateSchool/2-1.png
// module id = E1e3
// module chunks = 1